import useSWRImmutable from "swr/immutable"

import { useGetUserData } from "../../../../hooks/useGetUserData"
import { getClientProtected } from "../../clients/clients"
import { LIST_IDENTIFIER_GROUPS } from "../../urls/private"

export interface IdentifierGroup {
    organisationId: string
    organisationName: string
}

export interface IListIdentifierGroups {
    groups: IdentifierGroup[]
    isLoading: boolean
    isError: boolean
}

const isIdentifierGroupArray = (arg: unknown): arg is IdentifierGroup[] =>
    Array.isArray(arg) &&
    arg.every(
        (item) =>
            typeof item === "object" &&
            "organisationId" in item &&
            "organisationName" in item
    )

export const useIdentifierGroups = (): IListIdentifierGroups => {
    const { isEnaSysAdmin } = useGetUserData()
    const {
        data: groups,
        error,
        isLoading,
    } = useSWRImmutable(
        isEnaSysAdmin ? LIST_IDENTIFIER_GROUPS() : null,
        async (url: string): Promise<IdentifierGroup[]> => {
            try {
                const res = await getClientProtected(url)
                if (isIdentifierGroupArray(res)) {
                    return res
                }
                throw Error()
            } catch {
                throw Error()
            }
        }
    )
    return { groups: groups || [], isLoading, isError: error }
}
